var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#6921C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3998 19.1168L20.6731 13.3664C21.2062 12.8779 22.0672 12.8779 22.6002 13.3664C23.1333 13.855 23.1333 14.6443 22.6002 15.1329L17.2973 20.0063L22.6002 24.8671C23.1333 25.3557 23.1333 26.145 22.6002 26.6336C22.0672 27.1221 21.2062 27.1221 20.6731 26.6336L14.3998 20.8832C13.8667 20.4072 13.8667 19.6054 14.3998 19.1168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopClose);
export default __webpack_public_path__ + "static/media/PopClose.5be0abaa.svg";
export { ForwardRef as ReactComponent };